import TVdxbApplicationInviteUserFormHoujin from './index.vue';

TVdxbApplicationInviteUserFormHoujin.install = app => {
  app.component(TVdxbApplicationInviteUserFormHoujin.name, TVdxbApplicationInviteUserFormHoujin);
};

export default TVdxbApplicationInviteUserFormHoujin;
